import type { NavLink } from "../types/navLink";

export const NAV_LINKS: NavLink[] = [
  { label: "Home", target: "home" },
  { label: "About", target: "about" },
  { label: "Experience", target: "experience" },
  { label: "Skills", target: "skills" },
  { label: "Education", target: "education" },
  { label: "Projects", target: "projects" },
  { label: "Contact", target: "contact" },
];
